<div [formGroup]="form">
  <label
    for="{{ item.formControlName }}"
    class="custom-form-field__label"
  >{{ item.label }}</label>
  <p-dropdown
    id="{{ item.formControlName }}"
    [options]="options"
    [formControlName]="item.formControlName"
    [placeholder]="item.placeholder && item.placeholder !== 'undefined' ? item.placeholder : ''"
    [showClear]="true"
    [optionLabel]="optionLabel"
    optionValue="value"
    [autoDisplayFirst]="false"
    [attr.aria-describedby]="item.formControlName + '-hint'"
  ></p-dropdown>
</div>
